import { styled } from '@mui/material/styles'
import { Colors } from 'constants/colors'

const TextFieldContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  '& > p': {
    width: '100px',
    fontStyle: 'italic',
  },
  marginBottom: '20px',
})

const Title = styled('p')({
  fontSize: '24px',
  fontWeight: 700,
  color: Colors.white,
  margin: 0,
  padding: 0,
})

const SubTitle = styled('p')({
  fontsize: '14px',
  fontWeight: 400,
  color: Colors.darkCoolGray,
  opacity: 0.7,
  margin: 0,
  padding: 0,
})

const PlanBox = styled('div')({
  border: '1px solid #ccc',
  borderRadius: '10px',
  display: 'flex',
  padding: '15px 30px',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginTop: '15px',
  marginBottom: '5px',
})

const AdditionalActions = styled('span')({
  color: Colors.darkCoolGray,
  fontSize: '14px',
  textDecoration: 'underline',
  cursor: 'pointer',
})

const ProfileStyle = {
  TextFieldContainer,
  Title,
  SubTitle,
  PlanBox,
  AdditionalActions,
}

export default ProfileStyle
